// src/pages/PaidConsult.jsx
import { useEffect, useState } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../context/AuthContext";
import { useLanguage } from "../context/LanguageContext";
import ChatRoom from "../components/ChatRoom";

export default function PaidConsult() {
  const { user, profile } = useAuth();
  const { lang } = useLanguage();
  const [chatId, setChatId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function findDoctor() {
      if (!user) return;
      // Find the chat assigned to this user
      const q = query(
        collection(db, "chats"),
        where("participants", "array-contains", user.uid),
        where("type", "==", "paid")
      );
      const snap = await getDocs(q);
      if (!snap.empty) {
        setChatId(snap.docs[0].id);
      } else {
        // Default chat id using user uid (doctor will connect)
        setChatId(`paid_${user.uid}`);
      }
      setLoading(false);
    }
    findDoctor();
  }, [user]);

  if (loading) return <div className="loading-center"><div className="spinner" /></div>;

  return (
    <div className="page-content fade-in">
      <div className="container-md">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2>{lang === "ar" ? "معاينتك الطبية" : "Your Medical Consultation"}</h2>
            <p className="text-muted text-sm" style={{ margin: 0 }}>
              {lang === "ar" ? "محادثة مباشرة مع طبيبك المتخصص" : "Direct chat with your specialist doctor"}
            </p>
          </div>
          <div className="badge badge-green">{lang === "ar" ? "مشترك نشط" : "Active Subscriber"}</div>
        </div>

        {profile?.adhdProfile && (
          <div className="alert alert-info mb-4">
            <div>
              <strong>{lang === "ar" ? "ملف الطفل:" : "Child Profile:"}</strong>
              {" "}{profile.childName || lang === "ar" ? "طفلك" : "Your child"} —{" "}
              {lang === "ar" ? "العمر:" : "Age:"} {profile.childAge}{" "}
              {lang === "ar" ? "— درجة ADHD:" : "— ADHD Score:"} {profile.adhdProfile.percentage}%
            </div>
          </div>
        )}

        <ChatRoom
          chatId={chatId}
          title=""
        />
      </div>
    </div>
  );
}
